import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { PlayerService } from '../services/player.service';
import { ScrollService ,AuthService} from '../../api';
import { MdDialog, MdDialogRef } from '@angular/material';
import { CreateQuePlaylistComponent } from '../../playlists/create-que-playlist/create-que-playlist.component';

@Component({
  selector: 'view-queue',
  templateUrl: './view-queue.component.html',
  styleUrls: ['./view-queue.component.css']
})
export class ViewQueueComponent implements OnInit, OnDestroy {
  private playlist: Array<any> = new Array<any>();
  private playerEventSubscriber = null;
  @Output() refreshPlaylist: EventEmitter<any> = new EventEmitter();
  private queueCheck1 : boolean = true;
  dialogRef: MdDialogRef<CreateQuePlaylistComponent>;
  
  constructor(private authService: AuthService,private playerService: PlayerService, private scrollService: ScrollService,public dialog: MdDialog) {
    this.playlist = this.playerService.getPlaylistQue();
  }

  ngOnInit() {
    this.playerEventSubscriber = this.playerService.playerEvent.subscribe((event) => {
      if (event.type === 'track:id') { }
      if (event.type === 'player:playlist') {
        this.playlist = this.playerService.getPlaylistQue();
      }
    });
  }

  editPlaylist(event) {
    event.stopPropagation();
    event.preventDefault();
    this.dialogRef = this.dialog.open(CreateQuePlaylistComponent, {
      disableClose: false,
      width: '800px'
    });
    this.dialogRef.componentInstance.playlist = this.playlist;
    this.dialogRef.afterClosed().subscribe(result => {
      this.refreshPlaylist.emit({ refresh: 1 });
      this.dialogRef = null;
    });
  }

  refreshque(){
    this.playlist = this.playerService.getPlaylistQue();
  }

  ngOnDestroy() {
    if (this.playerEventSubscriber != null) {
      this.playerEventSubscriber.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/player/view-queue/view-queue.component.ts